import { Table, Text, ScrollArea, Box } from "@mantine/core";
import { StainMarkerVerificationResult } from "../../../services/admin/stains.service";
import StainMarkerVerificationStatusBadge from "./StainMarkerVerificationStatusBadge";

interface Props {
  results: StainMarkerVerificationResult[];
}

export default function StainMarkerVerificationResultsTable({
  results,
}: Props) {
  return (
    <ScrollArea h={400} offsetScrollbars>
      <Table striped highlightOnHover stickyHeader>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Stain</Table.Th>
            <Table.Th>Provider</Table.Th>
            <Table.Th>Marker Sent</Table.Th>
            <Table.Th>Status</Table.Th>
            <Table.Th>ACK</Table.Th>
            <Table.Th>ORC</Table.Th>
            <Table.Th>Reason/Error</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {results.map((result) => (
            <Table.Tr key={result.id}>
              <Table.Td>
                <Box>
                  <Text size="sm" fw={500}>
                    {result.stain?.code || "N/A"}
                  </Text>
                  <Text size="xs" c="dimmed">
                    ID: {result.stainId}
                  </Text>
                </Box>
              </Table.Td>
              <Table.Td>
                <Text size="sm">
                  {result.provider === "biocare" ? "Biocare" : "Leica"}
                </Text>
              </Table.Td>
              <Table.Td>
                <Text size="sm" ff="monospace">
                  {result.markerValueSent || "—"}
                </Text>
              </Table.Td>
              <Table.Td>
                <StainMarkerVerificationStatusBadge status={result.status} />
              </Table.Td>
              <Table.Td>
                <Text size="sm" ff="monospace">
                  {result.ackCode || "—"}
                </Text>
              </Table.Td>
              <Table.Td>
                <Text size="sm" ff="monospace">
                  {result.orderControl || "—"}
                </Text>
              </Table.Td>
              <Table.Td>
                <Text size="xs" c={result.errorMessage ? "red" : "dimmed"}>
                  {result.rejectionReason || result.errorMessage || "—"}
                </Text>
              </Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </ScrollArea>
  );
}
